import { useField } from "formik";
import { useEffect } from "react";
import {
  MustacheEditor,
  MustacheEditorProps,
} from "src/scenes/admin/components/MustacheEditor";
import { CustomFormInput, CustomFormInputProps } from "./CustomFormInput";

type Props = {
  name: string;
  mustacheProps?: MustacheEditorProps;
  initialValidationEnabled?: boolean;
} & Omit<CustomFormInputProps, "children" | "error">;

export function FormMustacheInput({
  mustacheProps,
  initialValidationEnabled,
  ...props
}: Props) {
  const { name } = props;
  const [field, meta, helper] = useField(name);

  useEffect(() => {
    if (initialValidationEnabled && field.value && !meta.touched) {
      helper.setTouched(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <CustomFormInput error={meta.error} {...props}>
      <MustacheEditor
        {...mustacheProps}
        containerProps={{
          height: "3.2rem",
          paddingBottom: "0.15rem",
          borderColor: meta.error ? "red.500" : "gray.200",
          _focusWithin: {
            borderColor: "blue.500",
            boxShadow: "0 0 0 1px #3182ce",
          },
          ...mustacheProps?.containerProps,
        }}
        {...field}
        onChange={(value) => {
          helper.setValue(value);
        }}
      />
    </CustomFormInput>
  );
}
